import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import banner1 from '../assets/banner1.jpg';
import banner4 from '../assets/banner4.jpg';
import { IoMdArrowDropright } from "react-icons/io";
import { FiCheckCircle } from "react-icons/fi";

export default function HomeBanner1(props) {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);
  const [bgIndex, setBgIndex] = useState(0);
  const banners = [banner4];

  useEffect(() => {
    setReady(false);
    // simulate init
    setTimeout(() => setReady(true), 200);
  }, []);

  // Background transition effect
  useEffect(() => {
    if (!ready) return;
    const interval = setInterval(() => {
      setBgIndex(prev => (prev + 1) % banners.length);
    }, 2500);
    return () => clearInterval(interval);
  }, [ready]);

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <div className="MainBodySection position-relative" style={{height: "100vh" }}>
      {banners.map((banner, i) => (
        <div
          key={i}
          style={{
            backgroundImage: `url(${banner})`,
            backgroundAttachment: "fixed",
            backgroundSize: "cover",
            backgroundPosition: "center",
            width: "100%",
            height: "100vh",
            position: "absolute",
            top: 0,
            left: 0,
            transition: "opacity 1.5s ease-in-out",
            opacity: i === bgIndex ? 1 : 0,
          }}
        />
      ))}

      {/* Gradient overlay */}
      <div style={{
        width: "100%",
        height: "100vh",
        background: "linear-gradient(to right, rgba(0,0,0,0.55), rgba(0,0,0,0.45))",
        position: "relative",
        zIndex: 1,
        display: "flex",
        alignItems: "center"
      }}>
        <div className="container py-5">
          <div className="row align-items-center py-3">

            {/* Text Column */}
            <div className="col-md-6 text-light">
              <h1 className="font-bold" style={{ fontSize: "3rem", lineHeight: "1.2" }}>
                Jenga Construction Limited
              </h1>
              <h3 className="text-light fw-semibold mt-3 mb-4" style={{ fontSize: "1.5rem" }}>
                Committed to delivering high-quality building and civil engineering solutions
              </h3>

              <div className="mb-4">
                <h6 className="d-flex align-items-center gap-2 mb-2">
                  <FiCheckCircle className="text-primary" size={24} /> Building Construction
                </h6>
                <h6 className="d-flex align-items-center gap-2 mb-2">
                  <FiCheckCircle className="text-primary" size={24} /> Civil Engineering Works
                </h6>
                <h6 className="d-flex align-items-center gap-2 mb-2">
                  <FiCheckCircle className="text-primary" size={24} /> Rehabilitation & Renovation
                </h6>
                <h6 className="d-flex align-items-center gap-2 mb-2">
                  <FiCheckCircle className="text-primary" size={24} /> Routine Maintenance
                </h6>
              </div>

              <div className="d-flex align-items-center gap-3 mt-4">
                <button
                  className="btn btn-primary btn-lg rounded-pill px-4"
                  onClick={() => appContext.navTo({ item: 'contact_us' })}
                >
                  Contact Us
                </button>
                <IoMdArrowDropright size={32} className="text-primary" />
              </div>
            </div>

            {/* Image Column */}
            <div className="col-md-6 mt-5 mt-md-0 d-flex justify-content-center">
              <div className="rounded-4 overflow-hidden shadow-lg  mDesktopOnly" style={{ width: "100%", maxHeight: "500px" }}>
                <img src={banner1} alt="Construction" className="img-fluid w-100 h-100 object-fit-cover" />
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
